import React from "react";
import { ArrowLeft, ArrowRight, Clock } from "lucide-react";
import { FadeUpGroup } from "../components/FadeUpGroup";
import { BLOG_POSTS, getBlogPost } from "../lib/blog";

export const BlogIndexPage = () => {
    return (
        <section className="section" data-testid="blog-index">
            <div className="container">
                <div className="section-head">
                    <span className="eyebrow">Insights</span>
                    <h1 className="h1" style={{ marginTop: 18 }}>Operator field notes</h1>
                    <p>Patterns we see across hundreds of growing businesses. No fluff. No listicles.</p>
                </div>
                <FadeUpGroup>
                    <div className="blog-grid">
                        {BLOG_POSTS.map((p) => (
                            <a key={p.slug} href={`/blog/${p.slug}`} className="case-card fade-up" data-testid={`blog-card-${p.slug}`}>
                                <span className="eyebrow" style={{ padding: "4px 10px" }}>{p.category}</span>
                                <h2 className="h3" style={{ marginTop: 14, fontSize: "1.3rem" }}>{p.title}</h2>
                                <p className="muted" style={{ marginTop: 10 }}>{p.excerpt}</p>
                                <div style={{ display: "flex", gap: 14, marginTop: 18, alignItems: "center", color: "var(--text-dim)", fontSize: "0.8rem" }}>
                                    <span>{p.date}</span>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}><Clock size={12} /> {p.readMinutes} min</span>
                                </div>
                                <span className="link-arrow" style={{ marginTop: 20, display: "inline-flex" }}>Read <ArrowRight size={16} /></span>
                            </a>
                        ))}
                    </div>
                </FadeUpGroup>
            </div>
        </section>
    );
};

export const BlogPostPage = ({ slug }) => {
    const post = getBlogPost(slug);
    if (!post) {
        return (
            <section className="section"><div className="container">
                <p className="muted">Post not found. <a href="/blog" className="link-arrow">Back to insights →</a></p>
            </div></section>
        );
    }
    return (
        <>
            <section className="section" data-testid={`blog-post-${post.slug}`}>
                <div className="container" style={{ maxWidth: 760 }}>
                    <a href="/blog" className="link-arrow" data-testid="blog-back-link" style={{ marginBottom: 18 }}>
                        <ArrowLeft size={14} /> All insights
                    </a>
                    <FadeUpGroup>
                        <div className="fade-up">
                            <span className="eyebrow">{post.category}</span>
                            <h1 className="h1" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)", marginTop: 18 }}>{post.title}</h1>
                            <div style={{ display: "flex", gap: 14, marginTop: 16, color: "var(--text-muted)", fontSize: "0.92rem" }}>
                                <span>{post.author} · {post.authorRole}</span>
                                <span>·</span>
                                <span>{post.date}</span>
                                <span>·</span>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}><Clock size={14} /> {post.readMinutes} min read</span>
                            </div>
                        </div>

                        <div className="blog-body fade-up" data-testid="blog-body">
                            {post.body.map((b, i) =>
                                b.kind === "h2" ? (
                                    <h2 key={i} className="h3" style={{ marginTop: 36, fontSize: "1.3rem" }}>{b.t}</h2>
                                ) : (
                                    <p key={i} style={{ marginTop: 18, color: "var(--text)", fontSize: "1.04rem", lineHeight: 1.75 }}>{b.t}</p>
                                )
                            )}
                        </div>
                    </FadeUpGroup>
                </div>
            </section>

            <section className="section" style={{ paddingTop: 0 }}>
                <div className="container">
                    <div className="cta-banner">
                        <div>
                            <h2 className="h2">Live the patterns, not the spreadsheets.</h2>
                            <p className="lead mt-4">See how Scitus.ai puts these ideas to work in 30 minutes.</p>
                        </div>
                        <a href="/contact" className="btn btn-primary btn-lg" data-testid={`blog-cta-${post.slug}`}>
                            Book a Demo <ArrowRight size={18} />
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default BlogIndexPage;
